<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-14 17:55:36
 * @LastEditTime: 2021-05-13 10:53:25
 * @LastEditors: JDY
-->
<template>
  <a-spin :spinning="loading">
    <a-form :form="form">
      <a-form-item label="选择证书" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          placeholder="请选择证书"
          name="crt_id"
          optionFilterProp="children"
          allow-clear
          v-decorator="['crt_id', { rules: [{ required: true, message: '请选择证书' }] }]"
        >
          <a-select-option v-for="crt in crtsList" :key="crt.id">{{ crt.title }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="考试模式" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          placeholder="请选择考试模式"
          name="mode_id"
          optionFilterProp="children"
          aloow-clear
          v-decorator="['mode_id', { rules: [{ required: true, message: '请选择考试模式' }] }]"
        >
          <a-select-option v-for="mode in modesList" :key="mode.id">
            {{ mode.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import { requestPut } from '@/api/api'
import { select } from '@/mixins' // 引入

const apiList = {
    crtsSelect: '/certificates/select',
    modesSelect: '/certificates/modes/select',
    translate: '/certificates/codes/translate'
}

export default {
    mixins: [select],
    props: {
        ids: {
            type: [Array, Object],
            required: true
        }
    },
    components: {},
    data () {
        return {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            modesList: [],
            modesLoad: false,
            crtsList: [],
            crtsLoad: false,
            loading: false,
            form: this.$form.createForm(this)
        }
    },
    mounted () {
        this.getSelectLists({
            url: apiList.crtsSelect,
            type: 'crtsList',
            load: 'crtsLoad'
        })
        this.getSelectLists({
            url: apiList.modesSelect,
            type: 'modesList',
            load: 'modesLoad'
        })
    },
    methods: {
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    if (!errors) {
                        values.id = this.$props.ids
                        requestPut(apiList.translate, values)
                            .then(res => {
                                this.$notification.success({
                                    message: res.msg
                                })
                                resolve(true) // 关闭弹出层
                            })
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>
